import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'twoDigitNumber'
})
export class TwoDigitNumberPipe implements PipeTransform {

    /**
     * Transforms a number so that it can always be displayed as two digit number
     * @param value
     */
    transform(value: number): string {
        if (value < 10) {
            return `0${value}`;
        }
        return value.toString();
    }

}
